module.exports = __webpack_public_path__ + "static/front-page-03-d63090f16ef2bcb1ad5ddfc3c80e20d4.jpg";